// BNB Address
const BNB_ADDRESS = '0x02f0826ef6aD107Cfc861152B32B52fD11BaB9ED'

export { BNB_ADDRESS }
